<template>
<div class="chapter">
<div class="inner_page">
<h1>Contents</h1>
<p class="toc"><a href="#/xhtml/05chapter01">Happiness Is . . .</a></p>
<p class="toc"><span href="#/xhtml/06author" title="Link target outside of Sample">About the Author</span></p>
<p class="toc"><span href="#/xhtml/100ebooks" title="Link target outside of Sample">Chronicle Ebooks</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04contents.vue?941e2bf2